import { render, staticRenderFns } from "./AdvertisementPopup.vue?vue&type=template&id=445ad02c"
import script from "./AdvertisementPopup.vue?vue&type=script&lang=js"
export * from "./AdvertisementPopup.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementPopup.vue?vue&type=style&index=0&id=445ad02c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports